<template>
    <v-container>
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>
                    <br>
                    {{$t('cellphone_wrong')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogImageFront = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>

                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingFront()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogImageBack = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogImageProfile = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil Residente     -->
        <v-dialog v-model="dialogImageProfileResident" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogImageProfileResident = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfile2URL"
                            ref="clipperImageProfile2"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfileResident()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo de progreso    -->
        <v-dialog
                v-model="dialog_progress"
                max-width="500"
        >
            <div>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        <v-icon right dark>mdi-home-edit</v-icon>
                        {{$t('enviar_datos')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-flex xs12>
                    <v-progress-linear
                            color="white"
                            indeterminate
                            rounded
                            height="12"
                    ></v-progress-linear>
                </v-flex>
            </div>
        </v-dialog>
        <!--    Diálogo Modal para dar de Alta Residente(s)    -->
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <v-dialog v-model="dialog_residente" scrollable max-width="400">
                <v-card>
                    <v-toolbar dark  color="primary">
                        <v-toolbar-title>
                            {{formTitle}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialog_residente = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text align="center">
                        <v-layout row wrap>
                            <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
                                <v-label>
                                    {{$t('foto_perfil')}}
                                </v-label>
                                <br>
                                <div class="wrapper">
                                    <img
                                            :src="editedItem.avatar"
                                            v-if="editedItem.avatar">
                                </div>
                                <br>
                                <v-btn
                                        color="primary">
                                    <clipper-upload
                                            @input="dialog = false, dialogImageProfileResident = true, degrees = 0, ratio = '1'"
                                            accept="image/*"
                                            v-model="imageProfile2URL"
                                    >
                                        {{$t('subir_imagen')}}
                                    </clipper-upload>
                                </v-btn>
                                <br>
                                <v-alert
                                        v-if="errores_ter.avatar"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                >
                                    {{errores_ter.avatar}}
                                </v-alert>
                            </v-flex>
                            <br>
                            <v-flex xs12>
                                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="editedItem.first_name"
                                            name="first_name_re"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            outlined
                                            :error-messages="errors[0]"
                                    >
                                    </v-text-field>
                                </ValidationProvider>
                            </v-flex>
                            <v-flex xs12>
                                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="editedItem.last_name"
                                            name="last_name_re"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            outlined
                                            :error-messages="errors[0]"
                                    >
                                    </v-text-field>
                                </ValidationProvider>
                            </v-flex>
                            <v-flex xs12>
                                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="editedItem.email"
                                            name="email_re"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            outlined
                                            :error-messages="errors[0]"
                                    ></v-text-field>
                                </ValidationProvider>
                            </v-flex>
                            <v-flex xs12>
                                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="editedItem.password"
                                            name="password_re"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            outlined
                                            :error-messages="errors[0]"
                                    >
                                    </v-text-field>
                                </ValidationProvider>
                            </v-flex>
                            <v-flex xs12>
                                <v-label>{{$t('celular')}}</v-label>
                                <vue-tel-input
                                        class="mt-3 mb-3"
                                        v-model="editedItem.cellNumber"
                                        @onInput="onInputCellResident"
                                >
                                </vue-tel-input>
                            </v-flex>
                            <v-flex xs12>
                                <br>
                                <v-checkbox
                                        class="pl-3 pr-3"
                                        v-model="editedItem.puede_enviar"
                                        name="puede_enviar"
                                        :label="$t('puede_enviar')"
                                        outlined
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                        <!--                    <v-layout row wrap-->
                        <!--                              v-if="editedItem.puede_enviar"-->
                        <!--                    >-->
                        <!--                        <v-flex xs12 sm6>-->
                        <!--                            <v-text-field-->
                        <!--                                    class="pl-3 pr-3"-->
                        <!--                                    v-model="editedItem.password"-->
                        <!--                                    name="password_re"-->
                        <!--                                    type="password"-->
                        <!--                                    :label="$t('password')"-->
                        <!--                                    prepend-icon="mdi-lock"-->
                        <!--                                    outlined-->
                        <!--                            ></v-text-field>-->
                        <!--                        </v-flex>-->
                        <!--                    </v-layout>-->
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                medium
                                color="primary"
                                @click="dialog_residente = false"
                        >{{$t('cerrar')}}</v-btn>
                        <v-spacer/>
                        <v-btn
                                medium
                                color="primary"
                                :disabled="invalid"
                                @click="addResident()"
                        >{{$t('guardar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </ValidationObserver>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-toolbar class="mb-5" dark color="primary">
                        <v-toolbar-title>
                            <v-icon right dark>mdi-home-edit</v-icon>
                            {{$t('sign_up_house')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>{{$t('msg_signup_apartment')}}<br><br>
                        <v-divider></v-divider>
                        <!-- <br> -->
                        <v-form @submit.prevent="">
                            <h3>{{$t('datos_vivienda')}}</h3>
                            <br>
                            <v-layout row wrap>
                                <!-- <v-flex xs12 sm6>
                                    <v-autocomplete
                                            class="pl-3 pr-3"
                                            clearable
                                            v-model="idHousingUnit"
                                            :items="items"
                                            :search-input.sync="search"
                                            :loading="isLoadingSchools"
                                            no-data-text="Ningún Resultado"
                                            item-text="name"
                                            item-value="id"
                                            prepend-icon="mdi-home-group"
                                            :filter="customFilter2"
                                            :label="$t('Fraccionamientos')"
                                            :placeholder="$t('place_holder_housing_units')"
                                            :error-messages="errores.idHousingUnit"
                                            outlined
                                            autocomplete="off"
                                            @change="fillHouses"
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                                    v-bind="data.attrs"
                                                    :input-value="data.selected"
                                                    @click="data.select"
                                            >
                                                <v-avatar left>
                                                    <v-img :src="data.item.logo"></v-img>
                                                </v-avatar>
                                                {{ data.item.name }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item="data">
                                            <template v-if="typeof data.item !== 'object'">
                                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                            </template>
                                            <template v-else>
                                                <v-list-item-avatar>
                                                    <img :src="data.item.logo">
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                        </template>
                                    </v-autocomplete>
                                </v-flex> -->
                                <v-flex xs12 sm6>
                                    <v-autocomplete
                                            class="pl-3 pr-3"
                                            v-model="id_house"
                                            prepend-icon="mdi-home-city"
                                            :label="$t('accion')"
                                            :item-text="example2"
                                            item-value="id"
                                            :placeholder="$t('search_by_house_number')"
                                            :filter="customFilter"
                                            :error-messages="errores.idHouse"
                                            :items="houses"
                                            no-data-text="Ningún Resultado"
                                            clearable
                                            outlined
                                            :loading="loadingHouses"
                                            autocomplete="off"
                                    >
                                        <template v-slot:item="data">
                                            {{data.item.number === null ? 'n/a' : data.item.number}}
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
<!--                                <v-flex xs12 sm6>-->
<!--                                    <v-text-field-->
<!--                                            class="pl-3 pr-3"-->
<!--                                            v-model="nombre_calle"-->
<!--                                            prepend-icon="mdi-road"-->
<!--                                            :label="$t('nombre_calle')"-->
<!--                                            :error-messages="errores.street"-->
<!--                                            outlined-->
<!--                                    ></v-text-field>-->
<!--                                </v-flex>-->
<!--                                <v-flex xs12 sm3>-->
<!--                                    <v-text-field-->
<!--                                            class="pl-3 pr-3"-->
<!--                                            v-model="number_house"-->
<!--                                            prepend-icon="mdi-home-floor-1"-->
<!--                                            name="number_house"-->
<!--                                            :label="$t('numero_casa')"-->
<!--                                            :error-messages="errores.number"-->
<!--                                            outlined-->
<!--                                    >-->
<!--                                    </v-text-field>-->
<!--                                </v-flex>-->
                            </v-layout>
                            <v-divider></v-divider>
                            <!-- <br> -->
                            <h3 >{{$t('datos_residente_principal')}}</h3>
                            <!-- <v-checkbox
                                    v-model="residente_unico"
                                    name="residente_unico"
                                    :label="$t('unique_resident')"
                            >
                            </v-checkbox> -->
                            <br v-if="residente_unico === false">
                            <!-- <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="first_name"
                                            prepend-icon="mdi-account"
                                            name="first_name"
                                            :label="$t('Nombre')"
                                            :error-messages="errores_seg.first_name"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="last_name"
                                            prepend-icon="mdi-account-outline"
                                            name="last_name"
                                            :label="$t('Apellido')"
                                            :error-messages="errores_seg.last_name"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout> -->
                            <!-- <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores_seg.email"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="password"
                                            name="password"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            :error-messages="errores_seg.password"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout> -->
                            <!-- <v-layout row wrap>
                                <v-flex sm6 class="mr-3 ml-3">
                                    {{$t('celular')}}
                                    <vue-tel-input
                                            class="mt-3 mb-3"
                                            v-model="cellphoneMundial"
                                            @onInput="onInput"
                                    ></vue-tel-input>
                                    <v-alert outlined v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                                </v-flex>
                            </v-layout> -->
                            <v-layout row wrap>
                              <v-row no-gutters>
                                <v-col
                                  cols="12"
                                  sm="4"
                                >
                                    <div class="splash-info">
                                            <v-label>
                                                {{$t('foto_perfil')}}
                                            </v-label>
                                            <div class="wrapper">
                                                <img
                                                        :src="resultProfileURL"
                                                        v-if="resultProfileURL">
                                            </div>
                                            <v-alert
                                                    v-if="errores_seg.avatar"
                                                    type="error"
                                                    outlined
                                                    transition="scale-transition"
                                            >
                                                {{errores_seg.avatar}}
                                            </v-alert>
                                            <v-btn
                                                    color="primary">
                                                <clipper-upload
                                                        @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageProfileURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                        </div>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="4"
                                >
                                        <v-text-field
                                                class="pl-3 pr-3"
                                                v-model="first_name"
                                                prepend-icon="mdi-account"
                                                name="first_name"
                                                :label="$t('Nombre')"
                                                :error-messages="errores_seg.first_name"
                                                outlined
                                        >
                                        </v-text-field>
                                        <v-text-field
                                                class="pl-3 pr-3"
                                                v-model="last_name"
                                                prepend-icon="mdi-account-outline"
                                                name="last_name"
                                                :label="$t('Apellido')"
                                                :error-messages="errores_seg.last_name"
                                                outlined
                                        >
                                        </v-text-field>
                                            {{$t('celular')}}
                                            <vue-tel-input
                                                    class="mt-3 mb-3"
                                                    v-model="cellphoneMundial"
                                                    @onInput="onInput"
                                            ></vue-tel-input>
                                            <v-alert outlined v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="4"
                                >
                                        <v-text-field
                                                class="pl-3 pr-3"
                                                v-model="email"
                                                prepend-icon="mdi-email"
                                                name="email"
                                                label="E-Mail"
                                                :error-messages="errores_seg.email"
                                                outlined
                                        >
                                        </v-text-field>
                                        <v-text-field
                                                class="pl-3 pr-3"
                                                v-model="password"
                                                name="password"
                                                prepend-icon="mdi-lock"
                                                :label="$t('password')"
                                                :type="show ? 'text' : 'password'"
                                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="show = !show"
                                                :error-messages="errores_seg.password"
                                                outlined
                                        >
                                        </v-text-field>
                                </v-col>
                              </v-row>
                                    <!-- <v-flex xs12 sm4 class="edge pt-3 pb-3 pl-3 pr-3">
                                        <div class="splash-info">
                                            <v-label>
                                                {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                            </v-label>
                                            <br>
                                            <v-img
                                                    :src="resultFrontURL"
                                                    v-if="resultFrontURL"
                                                    width="auto"
                                                    height="200px"
                                            ></v-img>
                                            <br>
                                            <v-btn
                                                    color="primary">
                                                <clipper-upload
                                                        @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageFrontURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                            <br>
                                            <v-alert
                                                    v-if="errores_seg.idFront"
                                                    type="error"
                                                    outlined
                                                    transition="scale-transition"
                                            >
                                                {{errores_seg.idFront}}
                                            </v-alert>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4 class="edge pt-3 pb-3 pl-3 pr-3">
                                        <div class="splash-info">
                                            <v-label>
                                                {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                            </v-label>
                                            <br>
                                            <v-img
                                                    :src="resultBackURL"
                                                    v-if="resultBackURL"
                                                    width="auto"
                                                    height="200px"
                                            ></v-img>
                                            <br>
                                            <v-btn
                                                    color="primary">
                                                <clipper-upload
                                                        @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageBackURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                            <br>
                                            <v-alert
                                                    v-if="errores_seg.idBack"
                                                    type="error"
                                                    outlined
                                                    transition="scale-transition"
                                            >
                                                {{errores_seg.idBack}}
                                            </v-alert>
                                        </div>
                                    </v-flex> -->
                                    <!-- <v-flex xs12 sm4 class="edge pt-3 pb-3 pl-3 pr-3">
                                    </v-flex> -->
                                </v-layout>
                            <br v-if="residente_unico === false">
                            <v-divider v-if="residente_unico === false"></v-divider>
                            <!-- <br> -->
                            <h3 v-if="residente_unico === false">{{$t('datos_residentes')}}</h3>
                            <br v-if="residente_unico === false">
                            <v-btn
                                    v-if="residente_unico === false"
                                    color="primary"
                                    dark
                                    @click="resultProfile2URL = '', cleanFields(), dialog_residente = true"
                            >+ {{$t('agregar_residente')}}</v-btn>
                            <br v-if="residente_unico === false">
                            <br v-if="residente_unico === false">
                            <v-data-table
                                    v-if="residente_unico === false"
                                    :headers="headers"
                                    :items="residentes"
                                    :footer-props="{
                                        itemsPerPageOptions: [
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}
                                        ],
                                        itemsPerPageText: $t('filas_por_pagina')
                                    }"
                                    :no-data-text="$t('no_records_yet')"
                                    class="elevation-1"
                            >
                                <template v-slot:item.first_name="{ item }">
                                    {{ item.first_name}}
                                    <div v-if="errores_ter[residentes.indexOf(item)]"  class="red--text">{{errores_ter[residentes.indexOf(item)].first_name}}</div>
                                </template>
                                <template v-slot:item.last_name="{ item }">
                                    {{ item.last_name}}
                                    <div v-if="errores_ter[residentes.indexOf(item)]" class="red--text">{{errores_ter[residentes.indexOf(item)].last_name}}</div>
                                </template>
                                <template v-slot:item.email="{ item }">
                                    {{ item.email}}
                                    <div v-if="errores_ter[residentes.indexOf(item)]" class="red--text">{{errores_ter[residentes.indexOf(item)].email}}</div>
                                </template>
                                <template v-slot:item.cellNumber="{ item }">
                                    {{ item.cellNumber}}
                                    <div v-if="errores_ter[residentes.indexOf(item)]" class="red--text">{{errores_ter[residentes.indexOf(item)].cellNumber}}</div>
                                </template>
                                <template v-slot:item.puede_enviar="{ item }">
                                    <v-icon
                                            v-if="item.puede_enviar === true"
                                            medium
                                            color="primary"
                                            class="mr-2"
                                    >
                                        mdi-check
                                    </v-icon>
                                    <v-icon
                                            v-if="item.puede_enviar === false"
                                            medium
                                            color="red"
                                            class="mr-2"
                                    >
                                        mdi-close
                                    </v-icon>
                                    {{ item.puede_enviar ? $t('Si') : 'No' }}
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-icon
                                            medium
                                            color="grey"
                                            class="mr-2"
                                            @click="editResident(item)"
                                    >
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon
                                            medium
                                            color="red"
                                            @click="deleteResident(item)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </v-data-table>
                            <!-- <br> -->
                            <v-divider></v-divider>
                            <br>
                            <v-btn
                                    color="primary"
                                    large
                                    @click="createHouseMainResidentsResidents()"
                            >
                                {{$t('enviar')}}
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import Vue from 'vue'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})
export default {
  name: 'signup_apartment',
  data: () => ({
    idHousingUnit: '',
    first_name: '',
    last_name: '',
    email: '',
    cellphone: '',
    custom_cell_phone: { },
    number_house: '',
    password: '',
    show: false,
    residente_unico: true,
    dialog_residente: false,
    editedIndex: -1,
    edit: false,
    editedItem: {
      first_name: '',
      last_name: '',
      email: '',
      username: '',
      cellNumber: '',
      password: '',
      puede_enviar: false,
      avatar: ''
    },
    defaultItem: {
      first_name: '',
      last_name: '',
      email: '',
      username: '',
      cellNumber: '',
      password: '',
      puede_enviar: false,
      avatar: ''
    },
    privadas: [],
    nombre_calle: '',
    residentes: [],
    headers: [],
    cellphoneMundial: '',
    dialog_progress: false,
    errores_seg: [],
    errores: [],
    // Photos
    dialogImageFront: false,
    dialogImageBack: false,
    dialogImageProfile: false,
    imageFrontURL: '',
    imageBackURL: '',
    imageProfileURL: '',
    resultFrontURL: '',
    resultBackURL: '',
    resultProfileURL: '',
    // Avatar Residentes
    dialogImageProfileResident: false,
    resultProfile2URL: '',
    imageProfile2URL: '',
    errores_ter: [],
    band_cellphone: true,
    band_cellphone_resident: false,
    dialogCellNumberWrong: false,
    houses: [],
    id_house: null,
    loadingHouses: false,
    degrees: 0,
    ratio: '1',
    search: null,
    entries: [],
    descriptionLimit: 60,
    isLoadingSchools: false,
    imageStatic: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAADAklEQVRo3u2ZzWuTQRDGf01txRgt9uMgtTdREUoDausHHiw9edeq9SIiHtSrVr1brzWtWvwTxJNf4OfFk+hJEdGTNVhoFBRLSSskHnZfKDHvZmd334RiHphDks0zM7uzs7Oz0EQT/zdaAvG0AoPAIWAXsAPYDGT07wvAN+Aj8BZ4CbwGSo2egD7gOpAHykL5CkwAvY0wvAeYAZYcDK+UJeAm0FUv408APwIYXikF4GiShrcBdxIwvFKmgTWhjU8Dj+pgfCT3gXUhZ15ifBGYBIaA9VqGgBv6N4kTQVZCEjZ5YMDAlUWWsaZ9jR8TzvyABWdWuBLOG7sHWbaZFHDnBLwFHFPsjEBJGXUS22KvkFscSluQH1IZAX9GyF0k5sROxSg4D7RLvRZAWoOtBc7ZDm7FrbZJMoTKwCxVJrzaCgziVmCdFIwdc+DvA3bbDLziMDtRnGYt+LO4F4HjNg7ccySPDjKTE1ncwjOSuzYOvPdQUNazm0PFeUbLPv2db/n9zsaBJErlUFKoNLbaJpbk83pjg40DqwrVytUFoNOTt4S6xP/SnztQqdm3ifDbxoE5BweWgSfAc+AV8AFYrBiTBnYCB4ERLdLTfs5mkCSNfkGVHS4r1glcQJ2wQdPoZQuiP3pciHqpHbiqOWvpvWRDWKtOWQaGAxheiRHNbdK9x4YohWo6xZFcTMD4COOYw9U6a04YiJJsQHUb9F6TEJkuNKcSdOB0jM7YC40Jt2LIFlG1TWjs19zVdOZcCLuB7zGEP7XCUDigOavpmsfjYD1GfEwWgTOehrcAZzG3WY74zs5tA3kZeAr0O/D2A89qcE/5Gg+qtfiwhqISqv14HNho4OpAdbcf6/+YOK1ai7bFVRp1jB+2GFsCPgOfUHENsAnYBmzFLpc/AEb5t57yQhvxmSmkTNnMvA9GUTej0IbPE2DD2qIL1e6TNGlN2SyH/x3ECb2oskNSEkcyiyoPvB75Qj2zplBNp2HUM+t2bdjKZ9Y8amO/AV6gnlsb/szaRBOrHX8BTX7HyUOjY8oAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDItMTVUMDA6MzU6MDErMDA6MDByOxknAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTAyLTE1VDAwOjM1OjAxKzAwOjAwA2ahmwAAAABJRU5ErkJggg=='
  }),
  watch: {
    search (val) {
      console.log(val)
      // Items have already been requested
      if (val !== null && val !== undefined) {
        if (val.length > 2) {
          this.isLoadingSchools = true
          // Lazily load input items
          const config = {
            method: 'get',
            url: 'https://clubtest.intrare.app/housing_units/filter?search=' + val,
            headers: {
              'Content-Type': 'application/json'
            }
          }
          axios(config)
            .then(response => {
              console.log(response.data)
              if (this.entries.length > 0) {
                for (var i = 0; i < response.data.length; i++) {
                  this.entries.push(response.data[i])
                }
              } else {
                this.entries = response.data
              }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => (this.isLoadingSchools = false))
        }
      }
    }
  },
  beforeUpdate () {
    this.custom_cell_phone = {
      'countrySelectorLabel': this.$t('codigo_pais'),
      'phoneNumberLabel': this.$t('celular'),
      'example': this.$t('ejemplo')
    }
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'center',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'center',
        sortable: true,
        value: 'last_name'
      },
      {
        text: this.$t('celular'),
        align: 'center',
        sortable: true,
        value: 'cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'center',
        sortable: true,
        value: 'email'
      },
      {
        text: this.$t('puede_enviar'),
        align: 'center',
        sortable: true,
        value: 'puede_enviar'
      }
    ]
  },
  computed: {
    ...mapState(['language']),
    formTitle () {
      return this.editedIndex === -1 ? this.$t('agregar_residente') : this.$t('editar_residente')
    },
    items () {
      return this.entries.map(entry => {
        const name = entry.name.length > this.descriptionLimit
          ? entry.name.slice(0, this.descriptionLimit) + '...'
          : entry.name
        return Object.assign({}, entry, { name })
      })
    }
  },
  created () {
    // this.initialize()
    this.getHouses()
  },
  methods: {
    initialize () {
      this.residentes = [
        {
          first_name: 'Andrés',
          last_name: 'Cruz Santiago',
          email: 'algo01@algo.com',
          username: 'algo01@algo.com',
          cellNumber: '4567891235',
          password: 'mientras123',
          avatar: 'dsfsadgafds',
          puede_enviar: true
        },
        {
          first_name: 'Francisco',
          last_name: 'Reyes Castillo',
          email: 'algo02@algo.com',
          username: 'algo02@algo.com',
          cellNumber: '0123456789',
          password: 'mientras123',
          avatar: 'dsfsadgafds',
          puede_enviar: false
        },
        {
          first_name: 'Gabriela',
          last_name: 'Guzmán Castro',
          email: 'algo03@algo.com',
          username: 'algo03@algo.com',
          cellNumber: '1212456488',
          password: 'mientras123',
          avatar: 'dsfsadgafds',
          puede_enviar: false
        }
      ]
    },
    gethousingUnits () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/housing_unit/all/',
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios(config)
        .then(response => {
          this.privadas = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getHouses () {
      this.loadingHouses = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/house/a58d8679-e2ae-4055-a243-c63d438f19eb/housingunit/',
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios(config)
        .then(response => {
          console.log(response.status)
          this.loadingHouses = false
          if (response.status !== 204) {
            this.houses = response.data
          } else {
            this.houses = []
          }
        })
        .catch(error => {
          this.loadingHouses = false
          console.log(error)
        })
    },
    addResident () {
      if (this.band_cellphone_resident === true) {
        this.editedItem.email = this.editedItem.email.toLowerCase()
        this.editedItem.username = this.editedItem.email
        this.editedItem.avatar = this.editedItem.avatar
        console.log(this.cellphoneMundial)
        if (this.editedIndex > -1) {
          Object.assign(this.residentes[this.editedIndex], this.editedItem)
        } else {
          this.residentes.push(this.editedItem)
          console.log('Resident Added')
        }
        this.close()
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    editResident (item) {
      this.editedIndex = this.residentes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_residente = true
    },
    deleteResident (aResident) {
      const index = this.residentes.indexOf(aResident)
      confirm('¿Está seguro de eliminar al Residente ' + aResident.first_name + ' ' + aResident.last_name + '?.\nEsta Acción no se puede deshacer!') && this.residentes.splice(index, 1)
    },
    createHouseMainResidentsResidents: function () {
      if (this.band_cellphone === true) {
        this.errores = []
        this.errores_seg = []
        this.errores_ter = []
        if (this.residente_unico === true) {
          this.residentes = []
        }
        // var permissions = this.getResidentPermissions(this.residentes)
        this.dialog_progress = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null
        var fileAvatar = null
        bodyFormData.set('idHousingUnit', 'a58d8679-e2ae-4055-a243-c63d438f19eb')
        bodyFormData.set('idHouse', this.id_house)
        bodyFormData.set('mainResident.first_name', this.first_name)
        bodyFormData.set('mainResident.last_name', this.last_name)
        bodyFormData.set('mainResident.cellNumber', this.cellphoneMundial)
        bodyFormData.set('mainResident.username', this.cellphoneMundial)
        bodyFormData.set('mainResident.email', this.email.toLowerCase())
        bodyFormData.set('mainResident.password', this.password)
        this.resultFrontURL = this.imageStatic
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          const newID = this.$uuid.v4()
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
        }
        bodyFormData.append('mainResident.idFront', fileImageFront)
        this.resultBackURL = this.imageStatic
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          const newID = this.$uuid.v4()
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
        }
        bodyFormData.append('mainResident.idBack', fileImageBack)
        const newID = this.$uuid.v4()
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
        }
        bodyFormData.append('mainResident.avatar', fileImageProfile)

        for (var i = 0; i < this.residentes.length; i++) {
          bodyFormData.set('residents[' + i + ']first_name', this.residentes[i].first_name)
          bodyFormData.set('residents[' + i + ']last_name', this.residentes[i].last_name)
          bodyFormData.set('residents[' + i + ']email', this.residentes[i].email)
          bodyFormData.set('residents[' + i + ']cellNumber', this.residentes[i].cellNumber)
          bodyFormData.set('residents[' + i + ']username', this.residentes[i].cellNumber)
          bodyFormData.set('residents[' + i + ']password', this.residentes[i].password)
          // console.log(this.students[i].avatar)
          if (this.residentes[i].avatar !== '' && this.residentes[i].avatar.length > 6) {
            const newID = this.$uuid.v4()
            fileAvatar = this.dataURLtoFile(this.residentes[i].avatar, 'avatar' + newID + '.jpeg')
          }
          bodyFormData.append('residents[' + i + ']avatar', fileAvatar)
          bodyFormData.append('can_send[' + i + ']', this.residentes[i].puede_enviar)
        }
        // if (this.residentes.length === 0) {
        //   console.log('NADDDDAAAA')
        //   console.log(this.residentes)
        //   bodyFormData.append('residents', this.residentes)
        //   bodyFormData.append('can_send', this.residentes)
        // }
        const config = {
          method: 'post',
          url: 'https://clubtest.intrare.app/home/create/',
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept-Language': this.language
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.dialog_progress = false
            console.log('OOOOOOOKKKKKKK')
            this.$router.push({ path: '/signup_apartment_success' })
          })
          .catch(error => {
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.dialog_progress = false
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.mainResident) {
                this.errores_seg = error.response.data.mainResident
              }
              if (error.response.data.residents) {
                console.log(error.response.data.residents)
                this.errores_ter = error.response.data.residents
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    close () {
      this.dialog_residente = false
      this.$refs.observer.reset()
      this.errores_ter = []
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    cleanFields () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.band_cellphone_resident = false
    },
    getCutingFront () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log('BASE64 = ', this.resultFrontURL)
      this.dialogImageFront = false
      this.dialog = true
    },
    getCutingBack () {
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultBackURL)
      this.dialogImageBack = false
      this.dialog = true
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultProfileURL)
      this.dialogImageProfile = false
      this.dialog = true
    },
    getCutingProfileResident () {
      const canvas = this.$refs.clipperImageProfile2.clip() // call component's clip method
      this.resultProfile2URL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultProfile2URL)
      this.editedItem.avatar = this.resultProfile2URL
      this.dialogImageProfileResident = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onInput ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      console.log(country)
      this.cellphoneMundial = number.e164
      this.band_cellphone = isValid
    },
    onInputCellResident ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      console.log(country)
      this.editedItem.cellNumber = number.e164
      this.band_cellphone_resident = isValid
    },
    getResidentPermissions (anArray) {
      var permissions = []

      for (var i = 0; i < anArray.length; i++) {
        permissions.push(anArray[i].puede_enviar)
      }
      return permissions
    },
    fillHouses () {
      console.log('Fill Houses')
      console.log(this.idHousingUnit)
      if (this.idHousingUnit === undefined) {
        this.houses = []
        this.id_house = null
      } else {
        this.getHouses()
      }
    },
    example2: item => (item.number === null ? 'n/a' : item.number),
    customFilter (item, queryText) {
      const textTwo = item.number === null ? 'n/a' : item.number.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textTwo.indexOf(searchText) > -1
    },
    customFilter2 (item, queryText) {
      const textOne = item.name.toLowerCase()
      if (queryText.length > 3) {
        const searchText = queryText.toLowerCase()
        return textOne.indexOf(searchText) > -1
      }
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #cf8918 #cf8918 #cf8918 #cf8918;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 1px solid #000000;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
